import { ForwardedRef, forwardRef, ReactNode } from 'react'
import { twMerge } from 'tailwind-merge'
import { Merge } from '../../util/types'

export interface CoreButtonProps {
  children: ReactNode
  className?: string | undefined
  variant?: 'primary' | 'secondary' | 'destructive' | 'plain'
}

type ButtonProps = Merge<React.ComponentProps<'button'>, CoreButtonProps>

export const Button = forwardRef(
  function Button ({
    variant = 'secondary',
    className,
    ...passthroughProps
  }: ButtonProps, ref: ForwardedRef<HTMLButtonElement>) {
    return (
      <button
        ref={ref}
        type='button'
        {...passthroughProps}
        className={twMerge(
          'core-button',
          'typo-body-medium flex items-center justify-center gap-2 rounded py-1.5 disabled:cursor-not-allowed disabled:opacity-50',

          // colour variants
          variant === 'plain' && 'bg-white px-1 text-black hover:bg-gray-100 active:bg-gray-200 disabled:bg-white',
          variant === 'primary' && 'bg-pink-500 px-4 text-white hover:bg-pink-550 active:bg-pink-600 disabled:bg-pink-550',
          variant === 'destructive' && 'bg-red-500 px-4 text-white hover:bg-red-550 active:bg-red-600 disabled:bg-red-550',
          // default
          variant === 'secondary' && 'bg-gray-200 px-4 text-black hover:bg-gray-300 active:bg-gray-400 disabled:bg-gray-300',

          className
        )}
      />
    )
  }
)
